import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import * as Yup from 'yup'
import { defaultMemberEnrollment } from './InterfaceMemberModal'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import closeIcon from '../../../../_metronic/images/closeSymbol.svg'
import { useFormik } from 'formik'
import { CREATE_DNES } from '../../../../utils/GraphQLAPI'
import { useMutation } from '@apollo/client'
import { Modal, Stack } from 'react-bootstrap'
import upload from '../../../../_metronic/images/FileUpload.svg'
import { useCSVReader } from 'react-papaparse'
import { alert } from '../../../../utils/helper'
import Tooltip from '../../../sharedComponent/CustomTooltip/Tooltip'


const MySwal = withReactContent(Swal)

type Props = {
  handleClose: () => void
  refetchList: () => void
  show: boolean
  method: string
  setRerender: any
  rerender: any
}

const enrollSchema = Yup.object().shape({
  phoneNumber: Yup.string(),
  utilityAccountNumber: Yup.string(),
  zipCode: Yup.string(),
})
type columnNameType = {
  phoneNumber: string,
  uanNumber: string
  Email: string
}
const columnNameConst: columnNameType = {
  phoneNumber: 'Phone Number',
  uanNumber: 'Utility Account Number',
  Email: 'Email Id'

}
const modalsRoot = document.getElementById('root-modals') || document.body

const UploadMemberModal = ({ handleClose, show, refetchList, method, rerender, setRerender }: Props) => {
  const [memberList, setMemberList] = useState([])
  const [uplodingMessage, setUplodingMessage] = useState(false)
  const [validationMsg, setValidationMsg] = useState<string>('')
  const { CSVReader } = useCSVReader()
  const [uploadMemberCount, setUploadMemberCount] = useState(0)
  const [createdData, setCreatedData] = useState('')
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false)
  const [fileUploadErr, setFileUploadErr] = useState(false);

  const handleClosePopUp = () => {
    setMemberList([]);
    setUploadMemberCount(0);
    handleClose();
    setCreatedData('')
  }
  const MAX_DNE_RECORDS = 10000;


  useEffect(() => {
    if (memberList.length > MAX_DNE_RECORDS) {
      setBtnDisabled(true)
      alert(`The selected file contains more than <strong>10,000 records</strong>.
   Please reduce the file size or contact <strong><a href="mailto:dev@tpvsolutions.com">dev@tpvsolutions.com</a></strong>
   for larger uploads.`, 'warning')
      setValidationMsg(`You can upload a maximum of ${MAX_DNE_RECORDS} records. Your file contains ${memberList.length} records.`)
      return;
    }
  }, [memberList])

  const formik = useFormik({
    initialValues: defaultMemberEnrollment,
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async () => {

      const payloadMembers = memberList.map((member: any) => {
        const updatedMember = { ...member };

        for (const key in updatedMember) {
          const formattedKey =
            key.charAt(0).toLowerCase() +
            key.slice(1).replace(/\s+/g, '');

          if (formattedKey !== key) {
            updatedMember[formattedKey] = updatedMember[key];
            delete updatedMember[key];
          }
        }
        return updatedMember;
      });

      const memberArray = [...payloadMembers];

      // Show loading popup
      MySwal.fire({
        title: 'Uploading...',
        html: 'Please wait while we upload your records. Do not refresh the page.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          MySwal.showLoading();
        }
      });

      try {
        while (memberArray.length > 0) {
          const chunk = memberArray.splice(0, 200);

          await createDoNotEnrollment({
            variables: {
              createDnesInput: chunk,
            },
          });
        }

        // Close loading popup and show success
        MySwal.fire({
          title: 'Upload successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        });

        refetchList();
        handleClosePopUp();
        setValidationMsg('');
        setRerender(true);

      } catch (error: any) {
        // Close loading popup and show error
        MySwal.fire({
          icon: 'error',
          title: error.message || 'Upload failed',
        });
      }
    }
  });


  // CREATE
  const [createDoNotEnrollment, { loading }] = useMutation(CREATE_DNES, {
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  useEffect(() => {
    if (createdData !== '') {
      const timeoutID = window.setTimeout(() => {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: createdData,
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
      }, 3000)

      return () => {
        window.clearTimeout(timeoutID);
        setRerender(false);
      }
    } else {
      setRerender(false)
      return () => {/*Left Intentional*/ }
    }
  }, [rerender]) // eslint-disable-line react-hooks/exhaustive-deps


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-750px'
      show={show}
      onHide={() => {
        handleClosePopUp();
        setValidationMsg('');
      }}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title '>Do Not Enroll List</h4>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={() => {
          handleClosePopUp();
          setValidationMsg('');
        }}>
          <img className='svg-icon-1' src={closeIcon} alt='close-icon' />
        </div>
      </div>

      <div className='modal-body'>
        <div className='modal-md'>
          <form noValidate id='kt_modal_create_app_form' onSubmit={formik.handleSubmit}>
            <div className='modal-content'>
              <div className='modal-body pt-0'>
                <div className='col-6 mb-2 mt-4 d-flex fw-bold fs-6'>
                  Do Not Enroll
                  <Tooltip text={
                    <>
                      You can upload a maximum of <strong>10,000 records</strong> for the Do Not Enroll list at one time.
                      <br />
                      If you need to upload a larger list, please contact <strong><a href="mailto:dev@tpvsolutions.com">dev@tpvsolutions.com</a>
                      </strong>
                    </>
                  } isLast={false} textClassName={'text-black fs-7 fw-normal'} />
                </div>

                <div className='upload-section m-0' style={{ cursor: 'pointer' }}>
                  <CSVReader
                    accept='.csv'
                    maxFiles={1}
                    onFile
                    onUploadAccepted={async (results: any) => {
                      setFileUploadErr(false);

                      if (results.data.length === 0) {
                        setValidationMsg('Atleast one field should be filled out')
                        setBtnDisabled(true)
                        return
                      }

                      const columnName = Object.keys(results.data[0])
                      if (columnName.length === 5) {
                        if (
                          columnName[0] === columnNameConst.phoneNumber &&
                          columnName[1] === columnNameConst.uanNumber &&
                          columnName[2] === 'Zip Code' &&
                          columnName[3] === 'Reason' &&
                          columnName[4] === columnNameConst.Email
                        ) {
                          let tempCount = 0
                          while (tempCount < results.data.length) {
                            const member = results.data[tempCount]

                            if (member[columnNameConst.phoneNumber] && member[columnNameConst.phoneNumber].length !== 10) {
                              setBtnDisabled(true)
                              setValidationMsg('Please check the CSV file. The phone number should be 10 digit number')
                              break
                            } else if (member[columnNameConst.uanNumber] && member[columnNameConst.uanNumber].length > 30) {
                              setValidationMsg("Please check the CSV file. The UAN shouldn't exceed 30 characters")
                              setBtnDisabled(true)
                              break
                            } else if (member['Zip Code'] && member['Zip Code'].length !== 5) {
                              setValidationMsg("Please check the CSV file. Enter a valid zip code")
                              setBtnDisabled(true)
                              break
                            }
                            else if (
                              member[columnNameConst.Email] &&
                              !/^[^\s,@]+@[^\s,@]+\.[^\s,@]+$/.test(member[columnNameConst.Email])
                            ) {
                              setValidationMsg("Email format is invalid")
                              setBtnDisabled(true)
                            }
                            else if (
                              member[columnNameConst.phoneNumber] === '' &&
                              member[columnNameConst.uanNumber] === '' &&
                              member['Zip Code'] === '' &&
                              member[columnNameConst.Email] === ''
                            ) {
                              setValidationMsg("Atleast one field should be filled out")
                              setBtnDisabled(true)
                              break
                            }


                            else {
                              setBtnDisabled(false)
                              setValidationMsg('')
                            }
                            tempCount++
                          }

                          // setBtnDisabled(false)
                          // setValidationMsg('')
                        }
                        else {
                          setUplodingMessage(false)
                          setValidationMsg('Headers are mismatched. Please upload a valid CSV format')
                          setBtnDisabled(true)
                        }
                      } else {
                        setUplodingMessage(false)
                        setValidationMsg('Please upload a valid format')
                        setBtnDisabled(true)
                      }

                      setMemberList(results.data)
                      setUplodingMessage(true)
                      setUploadMemberCount(results.data.length)
                      // setBtnDisabled(false) 
                    }}
                    onUploadRejected={async (file: any) => {
                      const tempError: any = file[0]?.errors[0];
                      if (tempError.code === 'file-invalid-type') {
                        setValidationMsg('');
                        setFileUploadErr(true);
                      }
                    }}
                    config={{
                      header: true,
                      skipEmptyLines: true,
                    }}
                    onDragOver={(event: DragEvent) => {
                      event.preventDefault()
                    }}
                    onDragLeave={(event: DragEvent) => {
                      event.preventDefault()
                    }}
                  >
                    {({
                      getRootProps,
                      acceptedFile,
                      ProgressBar,
                      getRemoveFileProps,
                      Remove,
                    }: any) => (
                      <>
                        <div
                          {...getRootProps()}
                        >
                          {acceptedFile ? (
                            <>
                              {/* {uplodingMessage ? ( */}
                              <div className='text-center'>
                                {!validationMsg && (
                                  <label className='uploaded-label'>
                                    {uplodingMessage && 'File uploaded successfully'}
                                  </label>
                                )}
                                {validationMsg && (
                                  <>
                                    <p className='mt-1 text-danger'>{validationMsg}</p>
                                    <Stack
                                      gap={2}
                                      className='align-items-center justify-content-center'
                                    ><img src={upload} alt='' width='40' height='40' className='svg-icon svg-icon-1' />
                                    </Stack>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>Upload CSV</span>
                                  </>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              <Stack gap={2} className='align-items-center justify-content-center'>
                                <img src={upload} alt='' width='40' height='40' className='svg-icon svg-icon-1' />
                                <span className='text-dark text-hover-primary fs-6'>
                                  Drop files here or click to upload
                                </span>
                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                  Upload CSV
                                </span>
                                {(!acceptedFile && fileUploadErr) && (
                                  <label className='uploaded-label err-label'>
                                    Please upload CSV file.
                                  </label>
                                )}
                              </Stack>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </CSVReader>
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-light'
                  data-bs-dismiss='modal'
                  onClick={() => {
                    handleClosePopUp();
                    setValidationMsg('');
                  }}
                >
                  Discard
                </button>
                <button type='submit' className='btn btn-primary' disabled={btnDisabled || loading}>
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm text-white"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {loading ? " Submiting..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export { UploadMemberModal }